import ShopifyBuy from 'shopify-buy';

const shopClient = ShopifyBuy.buildClient({
	accessToken: '9f0c39c7df29337f1971cf4231b3835a',
	domain: 'tabby-cat.myshopify.com',
	appId: '6',
});

const getFeaturedStickers = new Promise((resolve, reject) => {
	shopClient.fetchQueryProducts({ collection_id: 154704937047, sort_by: 'collection-default' })
		.then((productsFromShopify) => {
			resolve(productsFromShopify);
		})
		.catch((err) => {
			reject(`Oops, couldn't get stickers. Error: ${err}`);
		});
	});

const getCatStickers = new Promise((resolve, reject) => {
	shopClient.fetchQueryProducts({ collection_id: 154704052311, sort_by: 'collection-default' })
		.then((productsFromShopify) => {
			resolve(productsFromShopify);
		})
		.catch((err) => {
			reject(`Oops, couldn't get stickers. Error: ${err}`);
		});
	});

const getPetStickers = new Promise((resolve, reject) => {
	shopClient.fetchQueryProducts({ collection_id: 154704183383, sort_by: 'collection-default' })
		.then((productsFromShopify) => {
			resolve(productsFromShopify);
		})
		.catch((err) => {
			reject(`Oops, couldn't get stickers. Error: ${err}`);
		});
	});

const getCurrentStock = new Promise((resolve, reject) => {
	shopClient.fetchQueryProducts({ collection_id: 153771376727, sort_by: 'collection-default' })
		.then((productsFromShopify) => {
			resolve(productsFromShopify);
		})
		.catch((err) => {
			reject(`Oops, couldn't get stickers. Error: ${err}`);
		});
	});

const getStickers = new Promise((resolve, reject) => {
	shopClient.fetchQueryProducts({ collection_id: 421045844, sort_by: 'collection-default' })
		.then((productsFromShopify) => {
			resolve(productsFromShopify);
		})
		.catch((err) => {
			reject(`Oops, couldn't get stickers. Error: ${err}`);
		});
	});

const getMagnets = new Promise((resolve, reject) => {
	shopClient.fetchQueryProducts({ collection_id: 421045588, sort_by: 'collection-default' })
		.then((productsFromShopify) => {
			resolve(productsFromShopify);
		})
		.catch((err) => {
			reject(`Oops, couldn't get magnets. Error: ${err}`);
		});
	});

const getCart = new Promise((resolve, reject) => {
		if (localStorage.getItem('lastCartId')) {
			shopClient.fetchCart(localStorage.getItem('lastCartId'))
				.then((remoteCart) => {
					resolve(remoteCart);
				})
				.catch((err) => {
					reject(`Oops, couldn't get the remote cart. Error: ${err}`);
				});
		} else {
			shopClient.createCart()
				.then((newCart) => {
					resolve(newCart);
					localStorage.setItem('lastCartId', newCart.id);
				})
				.catch((err) => {
					reject(`There was a problem creating the cart. ${err}`);
				});
		}
	});

function clearLocalCart() {
	localStorage.removeItem('lastCartId');
}

module.exports = {
	getFeaturedStickers,
	getCatStickers,
	getPetStickers,
	getCurrentStock,
	getStickers,
	getMagnets,
	getCart,
	clearLocalCart,
};



// WEBPACK FOOTER //
// ./src/utils/shopify.js